import { render, staticRenderFns } from "./DriverAppPod.vue?vue&type=template&id=53067555&scoped=true"
import script from "./DriverAppPod.vue?vue&type=script&lang=js"
export * from "./DriverAppPod.vue?vue&type=script&lang=js"
import style0 from "./DriverAppPod.vue?vue&type=style&index=0&id=53067555&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53067555",
  null
  
)

export default component.exports